import { SET_ADMIN_USER } from '../action-types';
import {CreateCustomerRoutine} from '~modules/Companies/redux-routines';

export const initialState = {
  data: {},
};

export const adminUserRegistrationReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SET_ADMIN_USER:
      return {
        ...state,
        data: {...state.data, ...action.payload}
      };
    case CreateCustomerRoutine.SUCCESS:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
